module.exports = __webpack_public_path__ + "static/media/tests.2adeac7f.png";